import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import api from '../../../app/api/api';
import { fetchRestaurantListAsync } from './restaurantSlice';
import { CreateRestaurantFormData } from '../../../app/data/models/restaurants/createRestaurantFormData';

export interface CreateRestaurantsState {
  status: string;
  dismiss: boolean;
}

const initialState: CreateRestaurantsState = {
  status: 'idle',
  dismiss: false,
};

export const createRestaurantAsync = createAsyncThunk<
  void,
  CreateRestaurantFormData
>('restaurants/create', async (restaurant, thunkApi) => {
  try {
    // Create a copy of the restaurant data and handle location serialization
    const restaurantData: Partial<CreateRestaurantFormData> = {
      ...restaurant,
    };

    // Only include location if it exists and convert to string
    if (restaurant.location) {
      restaurantData.location = restaurant.location;
    }

    await api.Restaurant.create(restaurantData as CreateRestaurantFormData);
    thunkApi.dispatch(fetchRestaurantListAsync(undefined));
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkApi.rejectWithValue({ error: error.response?.data });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const createRestaurantSlice = createSlice({
  name: 'createRestaurant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createRestaurantAsync.pending, (state) => {
      state.status = 'pendingCreateRestaurant';
    });
    builder.addCase(createRestaurantAsync.fulfilled, (state) => {
      state.status = 'idle';
      state.dismiss = true;
    });
    builder.addCase(createRestaurantAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
